import React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {getCheckTrialStatus, getPaymentHistory} from '../../../../apis';
import {useAsync, useAsyncRetry} from '../../../../utils';
import {AppLoadingIndicator} from '../../../components';
import RequestTrialCard from './RequestTrialCard';
import SubscriptionCard from './SubscriptionCard';

const PlanCards = () => {
  const kids = useSelector((state) => state.general.kids);

  const {id: kidId} = kids?.[0] || {id: null};

  const {
    loading: paymentHistoryListLoading,
    value: paymentHistoryList,
  } = useAsync(() => getPaymentHistory(), []);

  const {
    loading: trialStatusLoading,
    value: trialStatus,
    retry: handleCheckTrialStatus,
  } = useAsyncRetry(() => getCheckTrialStatus({kidId}), [kidId]);

  const showRequestTrial =
    Array.isArray(paymentHistoryList) && !paymentHistoryList.length;

  if (paymentHistoryListLoading || trialStatusLoading) {
    return <AppLoadingIndicator />;
  }

  return (
    <View>
      {Boolean(trialStatus && !trialStatus.expireDate) && <SubscriptionCard />}
      {showRequestTrial && (
        <RequestTrialCard
          data={trialStatus}
          loading={trialStatusLoading}
          handleCheckStatus={handleCheckTrialStatus}
        />
      )}
    </View>
  );
};

export default PlanCards;
